module.exports = __webpack_public_path__ + "img/account-icon-dark.503c5be5.svg";